import React, { useEffect, useState } from "react";

const CerezPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cerezPopupClosed")) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem("cerezPopupClosed", "1");
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-7 left-6 z-50 bg-black bg-opacity-80 text-white text-sm rounded-lg p-3 shadow-lg flex flex-col items-start"
      style={{
        maxWidth: 270,
        minWidth: 180,
        minHeight: 120,
        position: "fixed",
      }}
    >
      <button
        onClick={handleClose}
        className="absolute top-1 right-2 text-white text-xl font-bold hover:text-gray-300 focus:outline-none"
        aria-label="Kapat"
        style={{ lineHeight: 1 }}
      >
        ×
      </button>
      <span>
        Size daha iyi hizmet sunabilmek adına çerezler kullanıyoruz. Detaylı
        bilgiye{" "}
        <a
          href="/gizlilik_cerez_politikasi"
          target="_blank"
          rel="noopener noreferrer"
          className="underline font-bold text-darkerGreen"
        >
          GİZLİLİK VE ÇEREZ POLİTİKASI
        </a>{" "}
        sayfamızdan erişebilirsiniz.
      </span>
    </div>
  );
};

export default CerezPopup;
